var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Grid", {
        ref: "grid",
        attrs: {
          service: _vm.service,
          order_column: "created_date_formatted",
          direction: "desc",
          route_name: "reporting_channel_handling"
        },
        scopedSlots: _vm._u([
          {
            key: "severity_level_str-column",
            fn: function(ref) {
              var row = ref.row
              return [
                _c("SeverityLevelBadge", {
                  attrs: {
                    label: row.severity_level_str || "-",
                    color:
                      (row.severity_level && row.severity_level.color) ||
                      "secondary"
                  }
                })
              ]
            }
          },
          {
            key: "status_str-column",
            fn: function(ref) {
              var row = ref.row
              return [
                _c("HandlingStatusBadge", {
                  attrs: {
                    label: row.status_str,
                    color:
                      (row.status && row.status.color) ||
                      row.status_label ||
                      "secondary"
                  }
                })
              ]
            }
          },
          {
            key: "actions",
            fn: function(actions) {
              return [
                _c(
                  "div",
                  { staticClass: "flex flex-row gap-2" },
                  [
                    _c("feather-icon", {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: "reporting_channel_handling.handling",
                          expression: "`reporting_channel_handling.handling`"
                        },
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top",
                          value: {
                            content: "Tratar formulário",
                            delay: { show: 100, hide: 100 }
                          },
                          expression:
                            "{\n            content: 'Tratar formulário',\n            delay: { show: 100, hide: 100 }\n          }",
                          modifiers: { top: true }
                        }
                      ],
                      staticClass:
                        "h-5 w-5 mb-1 mr-1 stroke-current text-warning",
                      attrs: { icon: "EditIcon" },
                      on: {
                        click: function($event) {
                          return _vm.handling(actions.row.id)
                        }
                      }
                    }),
                    _c("feather-icon", {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: "reporting_channel_handling.detail",
                          expression: "`reporting_channel_handling.detail`"
                        },
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top",
                          value: {
                            content: "Detalhar registro",
                            delay: { show: 100, hide: 100 }
                          },
                          expression:
                            "{\n            content: 'Detalhar registro',\n            delay: { show: 100, hide: 100 }\n          }",
                          modifiers: { top: true }
                        }
                      ],
                      staticClass:
                        "h-5 w-5 mb-1 mr-1 stroke-current text-warning",
                      attrs: { icon: "EyeIcon" },
                      on: {
                        click: function($event) {
                          return _vm.detail(actions.row.id)
                        }
                      }
                    }),
                    _c("feather-icon", {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: "reporting_channel_handling.delete",
                          expression: "`reporting_channel_handling.delete`"
                        },
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top",
                          value: {
                            content: "Excluir registro",
                            delay: { show: 100, hide: 100 }
                          },
                          expression:
                            "{\n            content: 'Excluir registro',\n            delay: { show: 100, hide: 100 }\n          }",
                          modifiers: { top: true }
                        }
                      ],
                      staticClass:
                        "h-5 w-5 mb-1 mr-1 stroke-current text-danger",
                      attrs: { icon: "Trash2Icon" },
                      on: {
                        click: function($event) {
                          return _vm.destroy(actions.row.id)
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }